import { components } from 'react-select';
import React from 'react';

const Input = props => <components.Input {...props} data-hj-allow />;
Input.propTypes = {};

export default Input;
